import { render, staticRenderFns } from "./ModalUser.vue?vue&type=template&id=9ecf1ed8&"
import script from "./ModalUser.vue?vue&type=script&lang=js&"
export * from "./ModalUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports